import React, { useState, useEffect } from "react"
import { Divider, Skeleton, Typography, Card, CardContent, TextField, Autocomplete } from '@mui/material'
import Modal from '../../Modal'
import Spinner from "../../Spinner"
import useProject from '../../../hooks/useProject'
import TreemapGraph from '../../Graphs/TreemapGraph'
import dashboardStyles from '../../../pages/Dashboard.module.scss'
import useFinancial from "../../../hooks/useFinancial"
import { useGeneral } from "../../../context/general"
import './NewsGraph.css'
import { Value } from "../../visualization-dropdown/Datasets.style"

export default function NewsGraph({graphData,Datasets}) {

    const [graph, setgraph] = useState(graphData)
    const { openVisualiztionWithTicker, handleOpenProject, tickers, setprojectTickerData } = useGeneral()
    const { createSampleGraph } = useProject()
    const [ modal, setModal ] = useState('')
    const [ projestParam, setProjectParam ] = useState({
        ticker:'',
        dataset:'',
        column:''
    })
    const { suggested } = useFinancial(projestParam.ticker)
    
    useEffect(() => {
        const { dataset, column, ticker } = projestParam
        if(dataset && column && ticker){
            (async () => {
                try {
                    setModal('Setting up project')
                    const project = await handleOpenProject(ticker, dataset, column)
                    await createSampleGraph(dataset, column, suggested, ticker, project.sections.at(-1))
                    await openVisualiztionWithTicker(project.uuid, ticker, true)
                    setModal('')
                } catch (e) {
                    console.error(e)
                    setModal('')
                }
            })()
        }
        return () => {}
    }, [projestParam]) // eslint-disable-line

    const newProject = (ticker, dataset = graph.dataset, column = graph.column) => {
        setProjectParam({ticker,dataset,column})
        setprojectTickerData(tickers.find(item=> item.value==ticker))
    }

    const handleCloseModal = () => setModal(false)

    return (
        <Card className="news-crd">
            <CardContent>
                <div style={{display:'flex',justifyContent:'space-between'}}>
                    <Typography variant="h3">
                        { graph?.title ? graph.title + ' - As of (' + graph.as_of_date + ')' : <Skeleton width="16em"/>}
                    </Typography>
                </div>
                <Typography variant="body2">
                    { tickers && graph?.dataset_label ? graph.dataset_label + ' & As of - ' + graph.as_of_date : <Skeleton width="8em"/>}
                </Typography>
                <div className={dashboardStyles['treemap-graph']}>
                    { tickers && graph?.data
                        ? graph?.data?.length == 0 ?<Typography style={{display:'flex',justifyContent:'center',paddingTop:'200px'}} >No data available</Typography>:<TreemapGraph data={graph.data} valueFormat={graph.valueFormat} datasetLabel={graph.dataset_label} timeFrameLabel={graph.time_frame_label} onClick={newProject}/> 
                        : <Skeleton height="100%" variant="rect"/>
                    }
                </div>
            </CardContent>
            <Divider/>
            <Modal open={!!modal} handleClose={handleCloseModal}>
                <div className="newsGraphModalContent">
                    <Spinner hasText={false} />
                    <Typography variant="h3">
                        {modal}
                    </Typography>
                </div>
            </Modal> 
        </Card>
    )
}


